import { Component, Mixins, Prop, VModel, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import Editorjs from '../editorJS/editorJS.vue'

import RichTextModel from '../models/richtext'
import EditorJSModel from '../models/editorJS'

@Component({
    name: 'rich-text',
    components: { Editorjs },
})
export default class RichText extends Mixins<MixinInterface>() {
    @VModel({ required: true }) richtext!: null | Record<string, any>
    @Prop({ required: true }) id!: string

    parcedRichtext = new RichTextModel(null)

    get vbitAttachment() {
        return this.$attrs.hasOwnProperty('vbitAttachment')
    }

    get vbitImage() {
        return this.$attrs.hasOwnProperty('vbitImage')
    }

    get vbitMention() {
        return this.$attrs.hasOwnProperty('vbitMention')
    }

    get vbitResource() {
        return this.$attrs.hasOwnProperty('vbitResource')
    }

    get editorjs() {
        return this.parcedRichtext.editorjs
    }

    set editorjs(data: Record<string, any>) {
        if (data) {
            this.parcedRichtext.editorjs = new EditorJSModel(data)
            this.richtext = {
                type: 'editorjs',
                data: data,
            }
        } else {
            this.richtext = null
        }
    }

    @Watch('id', { immediate: true })
    async initView() {
        await this.$nextTick()
        this.parcedRichtext = new RichTextModel(this.richtext)
    }
}
